<ng-container [formGroup]="formGroup">

  <mat-form-field>
    <mat-label>{{startDateLabel}}</mat-label>
    <label>
      <input
        name="startDate"
        [id]="startDateControl"
        [formControlName]="startDateControl"
        (dateChange)="setStartDate($event)" #startDateInput
        [matDatepicker]="startDatePicker" matInput
        [min]="minDate" [max]="maxStartDate"
        >
      @if (!validStartDate) {
        <mat-error>
          {{'Invalid date.' | translate}}
        </mat-error>
      }
    </label>
    <mat-datepicker-toggle [for]="startDatePicker" matSuffix [id]="startDateControl + 'Toggle'"></mat-datepicker-toggle>
    <mat-datepicker #startDatePicker></mat-datepicker>
  </mat-form-field>

  <mat-form-field>
    <mat-label>{{endDateLabel}}</mat-label>
    <label>
      <input
        name="endDate"
        [id]="endDateControl"
        [formControlName]="endDateControl"
        (dateChange)="setEndDate($event)" type="text" #endDateInput
        [matDatepicker]="endDatePicker" matInput
        [min]="minEndDate"
        >
      @if (!datesInOrder) {
        <mat-error>
          {{datesNotInOrderError}}
        </mat-error>
      }
      @if (!validEndDate) {
        <mat-error>
          {{'Invalid date.' | translate}}
        </mat-error>
      }
    </label>
    <mat-datepicker-toggle [for]="endDatePicker" matSuffix [id]="endDateControl + 'Toggle'"></mat-datepicker-toggle>
    <mat-datepicker #endDatePicker></mat-datepicker>
  </mat-form-field>

</ng-container>
